<section class="error-area ptb-100">
  <div class="container">
    @for (Content of errorContent; track Content) {
      <div class="error-content">
        <img [src]="Content.img" alt="Page not found">
        <h1>{{Content.title}}</h1>
        <p>{{Content.paragraphText}}</p>
        <div class="btn-box">
          <a href="##" class="default-btn" onClick="history.go(-1); return false;"><i class="{{Content.goBackBtnIcon}}"></i>{{Content.goBackBtnText}}<span></span></a>
          <a routerLink="/" class="default-btn"><i class="{{Content.BackToHomeBtnIcon}}"></i>{{Content.BackToHomeBtnText}}<span></span></a>
        </div>
      </div>
    }
  </div>
</section>